"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.themes = exports["default"] = void 0;
var _reactCssThemr = require("react-css-themr");
var _RadioGroup = _interopRequireDefault(require("./RadioGroup"));
// themes
require("./themes/DefaultTheme.css");
var DefaultTheme = {
  "RadioGroup": "DefaultTheme__RadioGroup___15wAj",
  "label": "DefaultTheme__label___33XVh",
  "orientation-horizontal": "DefaultTheme__orientation-horizontal___30H5P",
  "radios": "DefaultTheme__radios___17G0t",
  "radio": "DefaultTheme__radio___gzqtL",
  "orientation-vertical": "DefaultTheme__orientation-vertical___2BDz_",
  "radioGroup": "DefaultTheme__RadioGroup___15wAj",
  "orientationHorizontal": "DefaultTheme__orientation-horizontal___30H5P",
  "orientationVertical": "DefaultTheme__orientation-vertical___2BDz_"
};
require("./themes/DarkTheme.css");
var DarkTheme = {
  "RadioGroup": "DarkTheme__RadioGroup___1uxYY",
  "label": "DarkTheme__label___3fcyE",
  "radioGroup": "DarkTheme__RadioGroup___1uxYY"
};
require("./themes/LumeTheme.css");
var LumeTheme = {
  "RadioGroup": "LumeTheme__RadioGroup___2p0Ld",
  "radioGroup": "LumeTheme__RadioGroup___2p0Ld"
};
var themes = exports.themes = {
  DefaultTheme: DefaultTheme,
  DarkTheme: DarkTheme,
  LumeTheme: LumeTheme
};
var ThemedComponent = (0, _reactCssThemr.themr)('RadioGroup', themes.DefaultTheme)(_RadioGroup["default"]);
ThemedComponent.displayName = 'RadioGroup';
ThemedComponent.themes = themes;
ThemedComponent.isFormComponent = true;
var _default = exports["default"] = ThemedComponent;
//# sourceMappingURL=index.js.map